/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Live_Caption_Youtube_RegionInputs */



/**
* | output |
* | --- |
* | "Default YouTube region" |
*
* @param {Live_Caption_Youtube_RegionInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const live_caption_youtube_region = /** @type {((inputs?: Live_Caption_Youtube_RegionInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Live_Caption_Youtube_RegionInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Région YouTube par défaut")
	if (locale === "de") return /** @type {LocalizedString} */ ("Standard-YouTube-Region")
	if (locale === "it") return /** @type {LocalizedString} */ ("Regione predefinita di YouTube")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Регион YouTube по умолчанию")
	if (locale === "es") return /** @type {LocalizedString} */ ("Región predeterminada de YouTube")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("YouTube 默认区域")
	if (locale === "ja") return /** @type {LocalizedString} */ ("YouTubeのデフォルト地域")
	if (locale === "hi") return /** @type {LocalizedString} */ ("डिफ़ॉल्ट YouTube क्षेत्र")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Região padrão do YouTube")
	return /** @type {LocalizedString} */ ("Default YouTube region")
});